import React from 'react';

const styles = require('./index.less');

const LoadingIcon = () => {
  return (
    <div className={styles.root}>
      <div className="lds-ring">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default React.memo(LoadingIcon);
